// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav {
	width: 100%;
	display: flex;
	font-size: 14px;
    position: fixed;
    z-index: 1;
    background: rgba(216, 232, 229, 0);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(4.5px);
    -webkit-backdrop-filter: blur(4.5px);
    min-width: 44px;
    min-height: 44px;
}

.menu {
	width: 100%;
    margin: auto;
	text-align: right
}

.menu ul {
    padding-right: 50px;
    margin: 0;
}

.nav_item {
    box-sizing: border-box;
	display: inline-block;
	text-align: right;
	text-transform: uppercase;
	line-height: 24px;
}

.nav_item a {
    padding: 10px 20px;
    margin: 0;
    font-size: 1.5em;
}

.nav .logo {
    display: flex;
    align-items: center;
    margin-left:50px;
}

.nav .logo a {
    font-size: 30px;
	text-decoration: none;
	color: #F7E987;
    font-family: 'Pacifico', cursive;
}

.nav .menu a {
    margin: auto;
    font-size: 20px;
    border-radius: 15px;
	text-decoration: none;
	color: #F7E987;
}

.nav .logo a:hover,
.nav .menu a:hover {
    text-decoration: underline;
    opacity: 0.5;
    transition: 0.3s ease-in;
}`, "",{"version":3,"sources":["webpack://./src/styles/navbar.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,aAAa;CACb,eAAe;IACZ,eAAe;IACf,UAAU;IACV,kCAAkC;IAClC,yCAAyC;IACzC,4BAA4B;IAC5B,oCAAoC;IACpC,eAAe;IACf,gBAAgB;AACpB;;AAEA;CACC,WAAW;IACR,YAAY;CACf;AACD;;AAEA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,sBAAsB;CACzB,qBAAqB;CACrB,iBAAiB;CACjB,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;CAClB,qBAAqB;CACrB,cAAc;IACX,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;CACtB,qBAAqB;CACrB,cAAc;AACf;;AAEA;;IAEI,0BAA0B;IAC1B,YAAY;IACZ,wBAAwB;AAC5B","sourcesContent":[".nav {\n\twidth: 100%;\n\tdisplay: flex;\n\tfont-size: 14px;\n    position: fixed;\n    z-index: 1;\n    background: rgba(216, 232, 229, 0);\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(4.5px);\n    -webkit-backdrop-filter: blur(4.5px);\n    min-width: 44px;\n    min-height: 44px;\n}\n\n.menu {\n\twidth: 100%;\n    margin: auto;\n\ttext-align: right\n}\n\n.menu ul {\n    padding-right: 50px;\n    margin: 0;\n}\n\n.nav_item {\n    box-sizing: border-box;\n\tdisplay: inline-block;\n\ttext-align: right;\n\ttext-transform: uppercase;\n\tline-height: 24px;\n}\n\n.nav_item a {\n    padding: 10px 20px;\n    margin: 0;\n    font-size: 1.5em;\n}\n\n.nav .logo {\n    display: flex;\n    align-items: center;\n    margin-left:50px;\n}\n\n.nav .logo a {\n    font-size: 30px;\n\ttext-decoration: none;\n\tcolor: #F7E987;\n    font-family: 'Pacifico', cursive;\n}\n\n.nav .menu a {\n    margin: auto;\n    font-size: 20px;\n    border-radius: 15px;\n\ttext-decoration: none;\n\tcolor: #F7E987;\n}\n\n.nav .logo a:hover,\n.nav .menu a:hover {\n    text-decoration: underline;\n    opacity: 0.5;\n    transition: 0.3s ease-in;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
